import create from 'zustand';
import { ABAPQueryState } from './interfaces/CreateQueryState';
import { createCommonABAPQuerySlice } from './slices/ABAPQuerySlices/CommonABAPQuerySlice';

export const useABAPQueryStore = create<ABAPQueryState>((set) => ({
  ...createCommonABAPQuerySlice(set)
}));
